import React from "react";
import {
  Activity,
  BadgeCheck,
  CalendarDays,
  ClipboardList,
  Clock3,
  CircleDollarSign,
  ListTodo,
  Users,
} from "lucide-react";

const KPI_ICONS = [
  { match: /employee|team|user|headcount|staff/i, icon: Users },
  { match: /attendance|present|absent|late/i, icon: Activity },
  { match: /leave|holiday|calendar/i, icon: CalendarDays },
  { match: /task|pending|request/i, icon: ListTodo },
  { match: /payroll|salary|expense|cost|amount|revenue/i, icon: CircleDollarSign },
  { match: /approval|active|completed|paid/i, icon: BadgeCheck },
  { match: /hour|time|shift/i, icon: Clock3 },
];

function getFallbackIcon(label) {
  const match = KPI_ICONS.find(({ match: pattern }) => pattern.test(label || ""));
  const Icon = match?.icon || ClipboardList;
  return <Icon aria-hidden="true" />;
}

const KpiCard = ({
  label,
  value,
  sub,
  icon,
  color = "green",
  onClick,
}) => {
  const namedColor = ["blue", "green", "red", "amber", "purple"].includes(color)
    ? color
    : "custom";
  const cardStyle = namedColor === "custom" ? { "--kpi-accent": color } : undefined;

  return (
    <div
      className={`kpi-card kpi-card--${namedColor}`}
      style={cardStyle}
      onClick={onClick}
    >
      <div className="kpi-icon">
        {icon || getFallbackIcon(label)}
      </div>

      <div className="kpi-body">
        <h2 className="kpi-value">{value}</h2>

        <h4 className="kpi-label">{label}</h4>

        <p className="kpi-sub">{sub}</p>
      </div>
    </div>
  );
};

export default KpiCard;